const PORT_CODE=/^[A-Z0-9_]{3,120}$/;

export function safePortCode(value,fallback='PORT_OPERATION_FAILED'){
  const code=String(value??'').trim().toUpperCase();
  return PORT_CODE.test(code)?code:fallback;
}

export class PortError extends Error{
  constructor(code,{
    message,
    retryable=false,
    timeout=false,
    cancelled=false
  }={}){
    const safe=safePortCode(code);
    super(message?String(message):safe);
    this.name='PortError';
    this.code=safe;
    this.retryable=Boolean(retryable);
    this.timeout=Boolean(timeout);
    this.cancelled=Boolean(cancelled);
  }
}

export function createPortError(code,options){
  return new PortError(code,options);
}

export function isPortError(error){
  return error instanceof PortError
    ||(PORT_CODE.test(String(error?.code||''))&&typeof error?.retryable==='boolean');
}
